export default __webpack_public_path__ + "static/media/08.9f117cca.jpg";